export default{
    ApiUrl:"https://api.wikipk.net/api/",
    UploadPath:"https://battle-1301290517.cos.ap-guangzhou.myqcloud.com/",
    FileUploadAPI:"https://api.wikipk.net/fileupload",

    // ApiUrl: "http://api.52ranking.com/api/",
    // UploadPath: "http://huipaiming-1301290517.cos.ap-guangzhou.myqcloud.com/",
    // FileUploadAPI: "http://api.52ranking.com/fileupload",

    // ApiUrl:"https://cmsdev.app-link.org/alucard263096/battle/api/",
    // UploadPath:"https://alioss.app-link.org/alucard263096/battle/",
    // FileUploadAPI:"http://cmsdev.app-link.org/alucard263096/battle/fileupload",

    // ApiUrl:"https://api.kwyiot.com/api/",
    // UploadPath:"https://kawuyou.oss-cn-shenzhen.aliyuncs.com/",
    // FileUploadAPI:"https://api.kwyiot.com/fileupload",
}



// WEBPACK FOOTER //
// ./src/Config.js